import site from 'config';

export const featureSchema = {
	"@context": "https://schema.org/",
	"@type": "WebSite",
	name: "Sikka",
	url: site.siteMetadata.siteUrl,
	potentialAction: {
		"@type": "SearchAction",
		target: site.siteMetadata.siteUrl + "features{search_term_string}",
		"query-input": "required name=search_term_string",
	},
};
